import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const init = {
  tab: 'all'
}

export const useSearchTabStore = create(
  persist(
    (set) => ({
      ...init,
      setSearchTab: (tab) => set({ tab })
    }),
    {
      name: 'search-tab'
    }
  )
)